/* Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. */

import { Injectable, inject } from '@angular/core';
import { AuthOutputs } from '../auth/services/auth-outputs.service';
import { switchMap, take } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { AppState } from 'src/app/services/app-state.service';
import { AccountCreationStore } from '../auth/services/account-creation-store.service';
import { RallyPointService } from 'src/app/services/rally-point.service';
import { LoadingBlockerState } from '../utility-components/loading-blocker';
import { DefaultLoggerService } from '@touchplan/logging';

@Injectable()
export class RallyAuthOutputs extends AuthOutputs {
	private rallyPointService = inject(RallyPointService);
	private accountCreationStore = inject(AccountCreationStore);
	protected appState = inject(AppState);
	private logger = inject(DefaultLoggerService);

	//BEGIN PLACEHOLDER REPLACE AS PART OF TP-5569
	// re-examine this method as part of rally signup, it's... odd
	private waitAndTestCode() {
		this.accountCreationStore.setLoadingState(LoadingBlockerState.inProgress);
		this.appState.waitForUser$
			.pipe(
				take(1),
				switchMap((user) => this.accountCreationStore.accessCodeData$),
				//both methods can currently be exactly the same
				//but only due to the fairly silly state rallyPointSignupService is structured in
				//probably consider the best way to handle that in that ticket?
				switchMap((accessCodeData) => {
					if (accessCodeData) {
						return this.rallyPointService.testAccessCode$(accessCodeData);
					}
					console.log('code not loaded');
					return EMPTY;
				})
			)
			.subscribe(
				(redirectInfo) => {
					this.accountCreationStore.setLoadingState(LoadingBlockerState.empty);
					console.log(redirectInfo);
					if (redirectInfo?.route) {
						this.router.navigate(redirectInfo.route);
						this.accountCreationStore.setAccessCode(null);
					} else {
						console.log('something rally point broke', redirectInfo);
					}
				},
				(error) => {
					this.accountCreationStore.setLoadingState(LoadingBlockerState.failure);
					this.logger.error('Error while testing the access code', error);
				}
			);
	}
	//END PLACEHOLDER REPLACE AS PART OF TP-5569

	public finishLoginWithEmailAndPassword() {
		return this.waitAndTestCode();
	}

	public finishSignup() {
		return this.waitAndTestCode();
	}
}
